import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchImmobilizedDealeOrders = (filters = {}) =>
  apiActionCreator({
    'endpoint': '/orders/dealers/immobilized',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_IMMOBILIZED_DEALER_ORDERS,
      ActionTypes.FETCHED_IMMOBILIZED_DEALER_ORDERS,
      [
        ActionTypes.FETCHED_IMMOBILIZED_DEALER_ORDERS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    'data': filters,
  });

export const downloadImmobilizedDealeOrders = (filters = {}) =>
  apiActionCreator({
    'endpoint': '/orders/dealers/immobilized',
    'authenticated': true,
    'types': [
      ActionTypes.DOWNLOAD_IMMOBILIZED_DEALER_ORDERS,
      ActionTypes.DOWNLOAD_IMMOBILIZED_DEALER_ORDERS_SUCCESS,
      [
        ActionTypes.DOWNLOAD_IMMOBILIZED_DEALER_ORDERS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    'data': {
      ...filters,
      'generateFile': true,
    },
  });

export const clearImmobilizedDealeOrders = () => ({
  'type': ActionTypes.CLEAR_IMMOBILIZED_DEALER_ORDERS,
});

export const clearImmobilizedDealeOrdersFile = () => ({
  'type': ActionTypes.CLEAR_IMMOBILIZED_DEALER_ORDERS_URL_FILE,
});

export const changeImmobilizedDealeOrdersPage = (value) => ({
  'type': ActionTypes.CHANGE_IMMOBILIZED_DEALER_ORDERS_PAGE,
  'payload': value,
});

export const changeImmobilizedDealeOrdersPageSize = (value) => ({
  'type': ActionTypes.CHANGE_IMMOBILIZED_DEALER_ORDERS_PAGE_SIZE,
  'payload': value,
});
